// @ts-nocheck
import Abilities from "services/permissions/abilities";
import AvailableParkingActioner from "services/availableParking/actioner";
import ContractUtils from "services/contract/utils";
import { getFilters as parkedCarsGetFilters } from "services/parkedCars/utils";
import { getFilters as availableParkingGetFilters } from "services/availableParking/utils";
import HeatmapOccupancyActioner from "services/heatmapOccupancy/actioner";
import ParkedCarsActioner from "services/parkedCars/actioner";
import DisplaysActioner from "services/displays/actioner";
import ParkStatisticsActioner from "services/parkStatistics/actioner";
import LiveUtils from "services/live/utils";

import AvailableParkingActionTypes from "services/availableParking/types";
import ParkedCarsActionTypes from "services/parkedCars/types";
import LiveActionTypes from "services/live/types";

import MapApi from "./api";
import MapUtils from "./utils";
import MapActionTypes from "./types";

class MapActioner {
  static setConfig = (value) => {
    return {
      type: MapActionTypes.SET_CONFIG,
      value,
    };
  };

  static setConfigParam = (key, value) => {
    return {
      type: MapActionTypes.SET_CONFIG_PARAM,
      key,
      value,
    };
  };

  static setInitialized(value) {
    return {
      type: MapActionTypes.SET_INITIALIZED,
      value,
    };
  }

  static retrieveMapConfig(id) {
    return (dispatch) => {
      return MapApi.getMapConfig(id)
        .then((config) => {
          const formattedConfig = MapUtils.formatConfigFromApi(config);
          dispatch(MapActioner.setConfig(formattedConfig));
          dispatch(MapActioner.setInitialized(true));

          return Promise.resolve(formattedConfig);
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    };
  }

  static setCenterToDefault() {
    return (dispatch, getState) => {
      const defaultPosition = getState().Map.config.default_position;
      const defaultZoom = getState().Map.config.default_zoom;

      dispatch(MapActioner.setConfigParam("currentPosition", defaultPosition));
      dispatch(MapActioner.setConfigParam("currentZoom", defaultZoom));
    };
  }

  static setCatchmentAreaCenterToDefault() {
    return (dispatch, getState) => {
      const defaultPosition =
        getState().Map?.config?.visitor_characteristics?.default_position ||
        undefined;
      const defaultZoom =
        getState().Map?.config?.visitor_characteristics?.default_zoom || 10;
      dispatch(MapActioner.setConfigParam("currentPosition", defaultPosition));
      dispatch(MapActioner.setConfigParam("currentZoom", defaultZoom));
    };
  }

  static initFloorsDataFromModule(selectedModule) {
    return (dispatch, getState) => {
      const modulesWithFloors = [
        "non_moving_cars",
        "park_stats",
        "pedestrian_stats",
        "flow",
        "live",
      ];
      if (modulesWithFloors.indexOf(selectedModule) < 0) return;

      const currentModule =
        getState()?.Map?.config?.floorsConfig?.[selectedModule];
      let floors = currentModule?.displayedFloors || [];
      let currentFloor = currentModule?.defaultFloorSelected;

      if (selectedModule === "live") {
        const displayedFloors = Object.values(
          getState()?.Map?.config?.floorsConfig || {}
        )
          .map((item) => {
            return item?.displayedFloors || [];
          })
          .reduce((previous, current) => {
            return [...previous, ...current];
          }, new Map());

        floors = Array.from(
          displayedFloors
            .reduce((previousValue, currentValue) => {
              previousValue.set(currentValue?.name, currentValue);
              return previousValue;
            }, new Map())
            .values()
        );
      }

      floors = floors.sort((a, b) => (a.level > b.level ? -1 : 1));

      dispatch(MapActioner.setConfigParam("currentFloor", currentFloor));
      dispatch(MapActioner.setConfigParam("floors", floors));
    };
  }

  static retrieveMapDataForParkStatsTab() {
    return (dispatch, getState) => {
      const { contract } = getState()?.Contract;
      const { filters, map } = getState()?.ParkStatistics;

      if (
        // map?.initialized &&
        MapUtils.toggleMarkersAndAreas(
          filters?.timestamp,
          ContractUtils.getParkMaxDaysAllowed(contract)
        ) &&
        Abilities.ability.can("read", "park_stats.displayCircles")
      ) {
        Promise.all([
          dispatch(ParkedCarsActioner.retrieveList("areas")),
          dispatch(AvailableParkingActioner.retrieveList("areas")),
        ]).then(([parkCarsResult, availableParkingResult]) => {
          const apiTimestamp =
            parkCarsResult?.value?.others?.timestamp ||
            availableParkingResult?.value?.others?.availableParkingResult;
          if (apiTimestamp) {
            dispatch(
              ParkStatisticsActioner.setFilter("timestamp", apiTimestamp)
            );
          }
        });
      }

      if (
        map?.initialized &&
        MapUtils.toggleHeatmap(
          filters?.timestamp,
          ContractUtils.getParkMaxDaysAllowed(contract)
        )
      ) {
        dispatch(HeatmapOccupancyActioner.retrieveList("radius")).then(
          (result) => {
            const apiTimestamp = result?.value?.others?.timestamp;

            if (apiTimestamp) {
              dispatch(
                ParkStatisticsActioner.setFilter("timestamp", apiTimestamp)
              );
            }
          }
        );
      }
    };
  }

  static retrieveMapDataForDisplaysTab() {
    return (dispatch, getState) => {
      if (Abilities.ability.can("read", "tabs.config_displays")) {
        Promise.all([dispatch(DisplaysActioner.retrieveList())]);
      }
    };
  }

  static retrieveMapDataForLiveTab() {
    return (dispatch, getState) => {
      if (!Abilities.ability.can("read", "tabs.live")) {
        return null;
      }
      const { map } = getState()?.Live;
      let dataPromises = [];

      if (map?.initialized) {
        if (Abilities.ability.can("read", "tabs.park_stats")) {
          AvailableParkingActionTypes["SET_LIST"] =
            LiveActionTypes.SET_AVAILABLE_PARKING_LIST;
          ParkedCarsActionTypes["SET_LIST"] =
            LiveActionTypes.SET_PARKED_CARS_LIST;
          ParkedCarsActioner.utils.getFilters = LiveUtils.getParkedCarsFilters;
          AvailableParkingActioner.utils.getFilters =
            LiveUtils.getParkedCarsFilters;

          dataPromises = [
            ...dataPromises,
            dispatch(ParkedCarsActioner.retrieveList("areas")),
            dispatch(AvailableParkingActioner.retrieveList("areas")),
          ];
        }

        Promise.all(dataPromises).finally(() => {
          if (Abilities.ability.can("read", "tabs.park_stats")) {
            ParkedCarsActioner.utils.getFilters = parkedCarsGetFilters;
            AvailableParkingActioner.utils.getFilters =
              availableParkingGetFilters;

            AvailableParkingActionTypes["SET_LIST"] =
              "availableParking/SET_LIST";
            ParkedCarsActionTypes["SET_LIST"] = "parkedCars/SET_LIST";
          }
        });
      }
    };
  }
}

export default MapActioner;
